module.exports = __webpack_public_path__ + "img/logo.0730f07.png";